import React from 'react'
import { compose, withReducer, withHandlers } from 'recompose'
import { Spin } from 'antd'
import './App.scss'

const statusReducer = (status, action) => action.type
const dataReducer = (status, action) => action.data

export const withAsync = (asyncFunction) => (
  compose(
    withReducer('status', 'setStatus', statusReducer, 'START'),
    withReducer('data', 'setData', dataReducer, null),
    withHandlers({
      setStatus: (props) => (type) => props.setStatus({ type }),
      setData: (props) => (data) => props.setData({ data })
    }),
    handleSideEffect(asyncFunction)
  )
)

const handleSideEffect = (asyncFunction) => (Component) => ({ status, setStatus, setData, data, ...props }) => {
  if (status === 'START') {
    asyncFunction(props).then((result) => {
      setData(result)
      setStatus('SUCCESS')
    }).catch(() => {
      setStatus('ERROR')
    })
    setStatus('LOADING')
  }
  if (status === 'LOADING' || status === 'START') {
    return (
      <div className="loading">
        <Spin tip="กำลังโหลด..." />
      </div>
    )
  }
  if (status === 'ERROR') {
    return <h1 style={{ color: 'red' }}>ERROR</h1>
  }
  return <Component data={data} {...props} setData={setData} />
}

export default withAsync



// WEBPACK FOOTER //
// ./src/withAsync.js